/*门诊病历打印模板*/
export const medicalRecordOutpatient = {
    panels: [
        {
            index: 0,
            paperType: "A5",
            height: 148,
            width: 210,
            paperHeader: 442.5,
            paperFooter: 419.52755905511816,
            printElements: [
                {
                    options: {
                        left: 423,
                        top: 6,
                        height: 10.5,
                        width: 141,
                        title: "健康ID",
                        field: "patId",
                        fontSize: 8.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 6,
                        height: 406.5,
                        width: 564
                    },
                    printElementType: {
                        type: "rect"
                    }
                },
                {
                    options: {
                        left: 228,
                        top: 7.5,
                        height: 27,
                        width: 108,
                        title: "门诊病历",
                        fontFamily: "Microsoft YaHei",
                        fontSize: 21.75,
                        fontWeight: "900",
                        lineHeight: 20.25,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 423,
                        top: 21,
                        height: 1.5,
                        width: 141,
                        title: "就诊日期",
                        field: "seeDoctorDate",
                        lineHeight: 15,
                        fontSize: 8.25,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 409.5,
                        top: 42,
                        height: 7.5,
                        width: 162,
                        title: "血压",
                        field: "syspre",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 219,
                        top: 42,
                        height: 9,
                        width: 153,
                        title: "性别",
                        field: "sex",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 18,
                        top: 42,
                        height: 4.5,
                        width: 168,
                        title: "姓名",
                        field: "name",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 219,
                        top: 57,
                        height: 15,
                        width: 153,
                        title: "年龄",
                        field: "ageYear",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 18,
                        top: 58.5,
                        height: 13.5,
                        width: 168,
                        title: "科室",
                        field: "selDept",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 409.5,
                        top: 58.5,
                        height: 13.5,
                        width: 162,
                        title: "诊别",
                        field: "seedoctorcType",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 18,
                        top: 75,
                        height: 18,
                        width: 549,
                        title: "联系电话",
                        field: "conerTel",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 18,
                        top: 93,
                        height: 33,
                        width: 549,
                        title: "联系地址",
                        field: "conerAddName",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 18,
                        top: 126,
                        height: 19.5,
                        width: 549,
                        title: "食物、药物过敏原",
                        field: "aiseId",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 145.5,
                        height: 28.5,
                        width: 549,
                        title: "主诉",
                        field: "patientTell",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 174,
                        height: 28.5,
                        width: 549,
                        title: "现病史",
                        field: "nowHistory",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 202.5,
                        height: 28.5,
                        width: 549,
                        title: "既往史",
                        field: "beforeHistory",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 231,
                        height: 28.5,
                        width: 549,
                        title: "体格检查:",
                        fontSize: 11.25,
                        textContentVerticalAlign: "middle",
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 259.5,
                        height: 28.5,
                        width: 549,
                        title: "辅助检查:",
                        fontSize: 11.25,
                        textContentVerticalAlign: "middle",
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 288,
                        height: 28.5,
                        width: 549,
                        title: "西医诊断",
                        field: "westernDiagnos",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 19.5,
                        top: 316.5,
                        height: 75,
                        width: 549,
                        title: "诊疗意见",
                        field: "therapyOpinion",
                        fontSize: 11.25,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 181.5,
                        top: 393,
                        height: 7.5,
                        width: 190.5,
                        title: "医生签名",
                        field: "userId",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 376.5,
                        top: 393,
                        height: 15,
                        width: 190.5,
                        title: "日期",
                        field: "currentDate",
                        fontSize: 11.25,
                        lineHeight: 15,
                        textContentVerticalAlign: "middle"
                    },
                    printElementType: {
                        type: "text"
                    }
                }
            ],
            paperNumberLeft: 565.5,
            paperNumberTop: 397.5,
            paperNumberDisabled: true
        }
    ]
}